// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const SEND_USER_NOTIFICATION_STEP_SHAPES = [
  {
    stepType: PipelineStepType.SEND_USER_NOTIFICATION,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Result file': {
        systemName: 'Result file',
        displayName: 'Result file',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: false
      },
      'Result dataset': {
        systemName: 'Result dataset',
        displayName: 'Result dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: false
      },
      'Error file': {
        systemName: 'Error file',
        displayName: 'Error file',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: false
      }
    },
    outputDataShapes: {},
    config: {
      notificationType: {
        kind: 'enum',
        required: true,
        choices: [
          'PIPELINE_FAILURE',
          'NDC_FAILED_VALIDATION',
          'NDC_INGESTED'
        ]
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
